import { ArrowUpRightIcon, PackageCheckIcon, PackageIcon, TruckIcon } from 'lucide-react';
import { founder } from '../../data/content';
import { trackingUrl } from '../../core/rules/tracking';
import { btnPrimary } from '../../ui/styles';
import type { AccountOrder } from '../../core/types/account';
type Props = {
  order: AccountOrder;
  postcode?: string;
};

/**
 * De track & trace-regel van één bestelling. Elke status heeft een eigen, eerlijke tekst:
 * - in behandeling: nog geen code, en wanneer die komt (dit is de lege staat);
 * - onderweg met code: vervoerder, code en een volglink;
 * - onderweg zonder code: onderweg, en waar de code dan wél staat;
 * - bezorgd: kort bevestigd.
 */
export function OrderTracking({
  order: o,
  postcode
}: Props) {
  const row = 'flex flex-wrap items-center gap-x-3 gap-y-2 border-t border-line px-5 py-3.5 text-[14px] sm:px-6';
  const icon = 'h-4 w-4 shrink-0 text-clay';
  if (o.status === 'In behandeling') {
    return <div className={`${row} bg-sand/50`} data-id="element-6331" data-mp="281cdccnysaaa">
        <PackageIcon className={icon} strokeWidth={1.5} aria-hidden="true" data-id="element-6332" data-mp="9u90q6s5ve67" />
        <p className="min-w-0 flex-1 text-muted" data-id="element-6333" data-mp="9wddzfby9pj5">
          <span className="text-ink" data-id="element-6334" data-mp="52r8q8848nxd">Track & trace volgt.</span> Zodra {founder.firstName} je pakket verstuurt, staat de volglink hier en krijg je hem per mail.
        </p>
      </div>;
  }
  if (o.status === 'Bezorgd') {
    return <div className={row} data-id="element-6335" data-mp="3s6f9df2e2vfw">
        <PackageCheckIcon className={icon} strokeWidth={1.5} aria-hidden="true" data-id="element-6336" data-mp="st4qn5wzl6e8" />
        <p className="min-w-0 flex-1 text-muted" data-id="element-6337" data-mp="sr0q8xyaqpip">
          Bezorgd{o.tracking ? ` via ${o.tracking.carrier}` : ''}.
        </p>
      </div>;
  }

  // Onderweg
  return <div className={row} data-id="element-6338" data-mp="jqvj8ox0lt52">
      <TruckIcon className={icon} strokeWidth={1.5} aria-hidden="true" data-id="element-6339" data-mp="etlwxi4x9xlg" />
      {o.tracking ? <>
          <p className="min-w-0 flex-1 text-muted" data-id="element-6340" data-mp="34inwoacxsge3">
            <span className="text-ink" data-id="element-6341" data-mp="34kigtmgdw4h4">Onderweg met {o.tracking.carrier}.</span> Code <span className="font-mono text-[13px] text-ink" data-id="element-6342" data-mp="2zjkyn9vdjafm">{o.tracking.code}</span>
          </p>
          <a href={trackingUrl(o.tracking, postcode)} target="_blank" rel="noreferrer" className={`${btnPrimary} shrink-0 px-5 py-2.5`} data-id="element-6343" data-mp="310qcilje70wp">
            Volg je pakket
            <ArrowUpRightIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-6344" data-mp="2rzs8w4cv8ven" />
            <span className="sr-only" data-id="element-6345" data-mp="2w0m0b7piosca"> bij {o.tracking.carrier} (opent in een nieuw tabblad)</span>
          </a>
        </> : <p className="min-w-0 flex-1 text-muted" data-id="element-6346" data-mp="2i8p8z5voamgy">
          <span className="text-ink" data-id="element-6347" data-mp="2n2a851905mhq">Onderweg.</span> De track & trace staat in je verzendmail.
        </p>}
    </div>;
}